// no-dd-sa:javascript-code-style/strict-equals
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { Close as CloseIcon } from '@mui/icons-material';
import { isNull } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSetRecoilState, useRecoilState } from 'recoil';
import { ADD_DRIVER_SUCCESS, driverSelector, existedDriversState } from '../../../reducers/DriverReducer';
import { dspSelector, UPDATE_TOTAL_DRIVER_DSP_LIST } from '../../../reducers/DspReducer';
import { getDriver, insertDriver } from '../../../repositories/HttpRepository';
import useDebounce from './useDebounce';

const fields = [
  {
    id: 'id',
    label: 'id',
  },
  {
    id: 'name',
    label: 'Name',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'phone_number',
    label: 'Phone Number',
  },
  {
    id: '',
    label: '',
  },
];
const useStyles = makeStyles()((theme) => ({
  table: {
    minHeight: '120px',
    minWidth: '520px',
  },
  tableContain: {
    marginTop: '20px',
  },
  dialogAction: {
    padding: '8px 24px',
  },
  Table: {
    marginTop: 20,

    '& thead': {
      backgroundColor: theme.palette.secondary.main,

      '& th': {
        color: '#fff',
        padding: '4px 15px',
      },
    },
    '& tbody': {
      '& td': {
        padding: '4px 15px',
      },
    },
  },
  TableBody: {
    backgroundColor: '#fefefe',
  },

  Remove: {
    backgroundColor: '#fff',
  },
  TableRow: {
    height: 40,
  },
  AddedDrivers: {
    '& span': {
      fontSize: 14,
    },
    '& li': {
      padding: 0,
    },
  },
  AddBtn: {
    textTransform: 'uppercase',
    display: 'flex',
    justifyContent: 'space-between',
    color: '#737273',
    marginTop: 10,

    '& button': {
      backgroundColor: '#cccccc !important',
      color: '#fff',
      padding: '2px 25px',
    },
    '& button.active': {
      backgroundColor: '#8192a7 !important',
    },
  },
  CancelBtn: {
    border: 'solid 1px #4a4a4a',
    backgroundColor: '#ffffff',
    padding: '3px 15px',
  },
  SaveBtn: {
    backgroundColor: '#cccccc !important',
    padding: '4px 25px',
    color: '#fff',
    '&.active': {
      backgroundColor: '#4abc4e !important',
    },
  },
  DialogAction: {
    padding: 0,
    margin: theme.spacing(4, 0),
    marginRight: '24px',
  },
  DialogTitle: {
    '& h4': {
      fontWeight: 'bold !important',
    },
    '& svg': {
      padding: theme.spacing(1),
      top: 5,
      color: '#d8d8d8',
      right: 20,
      cursor: 'pointer',
      position: 'absolute',
      fontSize: 30,
    },
  },
}));
const useInputLabelStyles = makeStyles()(
  {
    root: {
      fontWeight: 600,
      fontFamily: 'AvenirNext',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      fontSize: 14,
    },
  },
  { name: 'MuiFormLabel' },
);

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, numSelected, rowCount, headCells } = props;
  const tmpHeadCells = [...headCells];
  tmpHeadCells.pop();
  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            color="primary"
            size="small"
            slotProps={{
              input: { 'aria-label': 'select all desserts' },
            }}
          />
        </TableCell>
        {tmpHeadCells.map((headCell) => (
          <TableCell key={headCell.id} align={headCell.align ? headCell.align : 'left'} padding={headCell.disablePadding ? 'none' : 'default'}>
            <Table>{headCell.label}</Table>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.object.isRequired,
};

const AddDriver = () => {
  const updateValuesDsp = useSetRecoilState(dspSelector);
  const updateValuesDriver = useSetRecoilState(driverSelector);
  const [driverId, setDriverId] = useState();
  const [driver, setDriver] = useState();
  const [datas, setDatas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { courierId } = useParams();
  const [keyword, setKeyword] = useState('');
  const [selected, setSelected] = React.useState([]);
  const [addedDrivers, setAddedDrivers] = React.useState([]);
  const [existedDriverIds, setExistedDriverIds] = useRecoilState(existedDriversState);
  const [firstClick, setFirstClick] = useState(false);

  const { classes } = useStyles();
  const navigate = useNavigate();
  useInputLabelStyles();
  const debounceDriverId = useDebounce(driverId, 500);
  useEffect(() => {
    if (debounceDriverId) {
      setIsLoading(true);
      getDriver(debounceDriverId).then((rsp) => {
        setIsLoading(false);
        if (rsp.ok) {
          setDriver(rsp.data);
        } else if (rsp.status && rsp.status === 404) {
          toast.error('Driver is not found');
        } else {
          toast.error('Server is having problem, please try again later');
        }
      });
    }
  }, [debounceDriverId]);

  function handleOnClickRemove(item) {
    /* empty */
  }

  function handleSearch(e) {
    setKeyword(e.target.value);
  }

  function handleResetSearch(e) {
    setKeyword('');
  }

  function handleKeyDown(e) {
    let keyword = e.target.value;

    if (e.key !== 'Enter') {
      return;
    }

    if (keyword === '') {
      e.preventDefault();
      return;
    }

    setIsLoading(true);
    getDriver(keyword).then((rsp) => {
      setIsLoading(false);
      if (rsp.ok) {
        setDatas([rsp.data]);
      } else if (rsp.status && rsp.status === 404) {
        toast.error('Driver is not found');
      } else {
        toast.error('Server is having problem, please try again later.');
      }
    });

    e.preventDefault();
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = datas.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  function removeAddedDriver(userId) {
    let tmp = addedDrivers.filter((obj) => {
      return obj.id !== userId;
    });
    setAddedDrivers(tmp);
  }

  function handleAddDriver(e) {
    let tmp = [...addedDrivers];

    selected.forEach((selectedID) => {
      // check existed in list
      let existed = false;
      tmp.forEach((el) => {
        if (selectedID == el.id) {
          existed = true;
        }
      });

      if (existed == true) {
        return;
      }

      let userInfo = {};
      datas.forEach((data) => {
        if (data.id == selectedID) {
          userInfo = data;
        }
      });

      if (Object.keys(userInfo).length == 0) {
        return;
      }

      tmp.push(userInfo);
    });
    setAddedDrivers(tmp);
  }

  function turnOffAddDriver() {
    setKeyword(null);
    navigate(-1);
  }

  function joinClassnames(...classnames) {
    return classnames.filter((i) => i).join(' ');
  }

  function handleSave(e) {
    if (firstClick == true) {
      return;
    }

    if (addedDrivers.length == 0) {
      return;
    }
    // no-dd-sa:javascript-code-style/assignment-name
    let drivers_ids = [];
    addedDrivers.forEach((addedDriver) => {
      drivers_ids.push(addedDriver.id);
    });

    setFirstClick(true);
    insertDriver(courierId, drivers_ids).then((rsp) => {
      if (rsp.ok) {
        updateValuesDriver({
          type: ADD_DRIVER_SUCCESS,
          payload: driver,
          totalAdded: drivers_ids.length,
        });
        updateValuesDsp({
          type: UPDATE_TOTAL_DRIVER_DSP_LIST,
          payload: { courierId, isAdded: true },
        });
        toast.success('Successfully added driver');
        navigate(`/dsp/drivers/${courierId}`, { replace: true });
      } else {
        toast.error(rsp?.data?.message ?? 'Can not add new driver, please try again later.');
        setFirstClick(false);
      }
    });
  }

  return (
    <Dialog
      open
      maxWidth="md"
      fullWidth
      onClose={() => {
        navigate(`/dsp/drivers/${courierId}`);
      }}
    >
      <DialogTitle id="form-dialog-add-driver" className={classes.DialogTitle}>
        <Typography variant="h4">Add Drivers</Typography>
        <CloseIcon onClick={turnOffAddDriver} />
      </DialogTitle>
      <DialogContent>
        {isLoading && <LinearProgress variant="query" />}

        <form>
          <TextField
            onChange={handleSearch}
            onKeyDown={handleKeyDown}
            variant="outlined"
            id="standard-start-adornment"
            placeholder="Search drivers by driver ID"
            fullWidth
            value={keyword}
            size="small"
            className={classes.searchInput}
            slotProps={{
              input: {
                startAdornment: <InputAdornment className={classes.SearchIcon} position="start"></InputAdornment>,
                endAdornment: keyword && (
                  <IconButton className={classes.CloseBtn} onClick={handleResetSearch} size="large">
                    <CloseIcon />
                  </IconButton>
                ),
              },
            }}
          />
        </form>
        <div className={classes.Table}>
          <Paper className={classes.Paper}>
            <TableContainer>
              <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                <EnhancedTableHead classes={classes} numSelected={selected.length} onSelectAllClick={handleSelectAllClick} rowCount={datas.length} headCells={fields} />
                <TableBody>
                  {Array.isArray(datas) && datas.length != 0 && !existedDriverIds.includes(datas[0].id)
                    ? datas.map((row, index) => {
                        const isItemSelected = isSelected(row.id);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            onClick={(event) => handleClick(event, row.id)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.id}
                            selected={isItemSelected}
                            className={classes.TableRow}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                size="small"
                                color="primary"
                                slotProps={{
                                  input: { 'aria-labelledby': labelId },
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">{row.id}</TableCell>
                            <TableCell align="left">
                              {row.first_name} {row.last_name}
                            </TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                            <TableCell align="center">{row.phone_number}</TableCell>
                          </TableRow>
                        );
                      })
                    : [1].map((row, index) => {
                        let msg = '';
                        if (Array.isArray(datas) && datas.length != 0 && existedDriverIds.includes(datas[0].id)) {
                          msg = 'This driver has been added to the DSP';
                        }
                        return (
                          <TableRow className={classes.TableRow}>
                            <TableCell align="center" colSpan={5} key={`msg-${index}`}>
                              {msg}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  {[2, 3, 4, 5].map((row, index) => {
                    return (
                      <TableRow className={classes.TableRow}>
                        <TableCell align="center" colSpan={5} key={`empty-${index}`} />
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
        <div className={classes.AddBtn}>
          <Typography variant="h4">ADDED DRIVERS:</Typography>
          <Button onClick={handleAddDriver} className={selected.length > 0 ? 'active' : ''}>
            ADD
          </Button>
        </div>
        <List className={classes.AddedDrivers}>
          {addedDrivers.map((row, index) => {
            return (
              <ListItem key={`added-driver-${index}`}>
                <ListItemText>
                  {index + 1}. <strong>name:</strong> {row.first_name} {row.last_name}, <strong>ID:</strong> {row.id}{' '}
                </ListItemText>
                <Link onClick={(e) => removeAddedDriver(row.id)}>Remove</Link>
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions className={classes.DialogAction}>
        <Button className={classes.CancelBtn} onClick={turnOffAddDriver}>
          CANCEL
        </Button>
        <Button className={addedDrivers.length > 0 ? joinClassnames(classes.SaveBtn, 'active') : classes.SaveBtn} onClick={handleSave}>
          SAVE
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default React.memo(AddDriver);
